import { Toaster } from "components/notification/Toaster";
import { func_cookie, isAccessTokenValid, isObjectNotEmpty, isStringTrimNotEmpty } from "functions";
import { useDispatch } from "react-redux";
import { generateEmailOTP_failure, generateEmailOTP_request, generateEmailOTP_success, getUserInfo_failure, getUserInfo_request, getUserInfo_success, loginModalVisiblity, login_failure, login_request, login_success, logout_failure, logout_request, logout_success, refreshAccessToken_failure, refreshAccessToken_request, refreshAccessToken_success, resetPassword_failure, resetPassword_request, resetPassword_success } from "../slices/authentication.slices";
import { promiseInstance, promiseInstance_authorization } from "./config";




export function useAuthenticationActions() {
	const dispatch = useDispatch();

	function login(loginInfoObj) {
        dispatch(login_request);
	
        promiseInstance().post('/User/Login', loginInfoObj)
            .then(function (details) {
                // handle success
                dispatch(login_success(details));
            })
            .catch(function (error) {
                // handle error
                dispatch(login_failure(error));
            })
            .finally(function () {
                // always executed
            });
	}
	
	function refreshAccessToken(onSuccess, onFailure_validAccessToken) {
        dispatch(refreshAccessToken_request());
	
        let refresh_token = func_cookie.getCookieValue("refresh_token_bp");
        let tokenInfo = {
            refresh_token: refresh_token,
            grant_type: "refresh_token"
        }

        promiseInstance().post('/User/RefreshToken', tokenInfo)
            .then(function (details) {
                // handle success
                dispatch(refreshAccessToken_success(details));

                if (onSuccess) onSuccess();
            })
            .catch(function (error) {
                // handle error
                dispatch(refreshAccessToken_failure(error));

                if (isAccessTokenValid("access_token_bp") && onFailure_validAccessToken) {
                    onFailure_validAccessToken();
                }
                else {
                    // Refresh token is invalid. Remove it and log out user.
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Authorization is invalid/expired";
                    Toaster({ type: "error", msg });

                    forceLogout();
                }
            })
            .finally(function () {
                // always executed
            });
	}
	
	function generateEmailOTP(email) {
        dispatch(generateEmailOTP_request());
	
        let email_validated = isStringTrimNotEmpty(email)? email:"";

        promiseInstance().get('/User/GenerateOtp?email='  + email_validated)
            .then(function (details) {
                // handle success
                dispatch(generateEmailOTP_success(details));
            })
            .catch(function (error) {
                // handle error
                let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate OTP";
                dispatch(generateEmailOTP_failure(msg));
            })
            .finally(function () {
                // always executed
            });
	}
	
	function resetPassword(userInfo) {
        dispatch(resetPassword_request());
	
        let userInfo_validated = isObjectNotEmpty(userInfo)? userInfo:{};
        
        promiseInstance_authorization(dispatch, resetPassword_request, (axios) => {
            axios.post('/User/ChangePassword', userInfo_validated)
                .then(function (details) {
                    // handle success
                    dispatch(resetPassword_success(details));
                    Toaster({ type: "success", msg: "Successfully reset password"});
                })
                .catch(function (error) {
                    // handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to reset password";

                    dispatch(resetPassword_failure(msg));

				    Toaster({ type: "error", msg });
                })
                .finally(function () {
                    // always executed
                });
        })
	}

    function forceLogout() {
        dispatch(logout_request());
        dispatch(logout_success());
    }
	
	function logout() {
        dispatch(logout_request());
	
        let logoutObj = {
            refresh_token: func_cookie.getCookieValue("refresh_token_bp"),
        }
        
        promiseInstance_authorization(dispatch, logout_request, (axios) => {
            axios.post('/User/LogoutUser', logoutObj)
                .then(function (details) {
                    // handle success
                    dispatch(logout_success(details));
                })
                .catch(function (error) {
                    // handle error
                    dispatch(logout_failure(error));
                })
                .finally(function () {
                    // always executed
                });
        })
	}
	
	function getUserInfo() {
        dispatch(getUserInfo_request());
	
        promiseInstance_authorization(dispatch, getUserInfo_request, (axios) => {
            axios.get('/User/LoginInfo')
                .then(function (details) {
                    // handle success
                    dispatch(getUserInfo_success(details));
                })
                .catch(function (error) {
                    // handle error
				    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get user info";
                    dispatch(getUserInfo_failure(msg));
                })
                .finally(function () {
                    // always executed
                });
        })
	}
	
	
	function toggleLoginModalVisibility(isModalVisible) {
        dispatch(loginModalVisiblity(isModalVisible));
	}

	return {
		login,
		refreshAccessToken,
	
		generateEmailOTP,
		resetPassword,
	
		forceLogout,
		logout,
	
		getUserInfo,
	
		toggleLoginModalVisibility,
	}
}
